export enum AuthStatus{
    NotLoggedIn,
    Loading,
    LoggedInButNotRegistered,
    LoggedIn,
    Error};
